import "intl-tel-input/build/css/intlTelInput.min.css";

export default _this => {
  _this.columns = [
    "phone",
    "name",
    "group",
    "jobs",
    "total",
    "black",
    "color",
    "prints",
    "copies",
    "scans"
  ];
  _this.data = [];
  let groups = [];
  if (_this.user.settings && _this.user.settings.clients) {
    const { clients, groups: userGroups } = _this.user.settings;
    for (const clientId of Object.keys(clients)) {
      const client = clients[clientId];
      const groupId = client.group;

      let group = {};
      if (userGroups && groupId && userGroups[groupId]) {
        group = userGroups[groupId];
      }

      const row = {
        DT_RowId: clientId,
        phone: client.phone.formatted.international,
        name: client.name,
        group: group.name
      };
      _this.data.push(row);
    }
    groups = Object.keys(userGroups || {}).map(key => {
      const { name } = userGroups[key];
      return {
        label: name,
        value: key
      };
    });
  }
  groups = [{ label: "", value: "" }, ...groups];

  $.each(_this.unique(_this.columns), (index, column) => {
    let title = column;
    let uniqueColumn = { data: column };
    let visible = true;
    uniqueColumn["title"] = _this.t(title);
    uniqueColumn["visible"] = visible;
    uniqueColumn["name"] = column;
    if (
      ["jobs", "total", "black", "color", "prints", "copies", "scans"].includes(
        column
      )
    ) {
      uniqueColumn["defaultContent"] = 0;
    }
    _this.uniqueColumns.push(uniqueColumn);
  });

  let { /* columns,  */ options } = _this.createTableProperties(_this);
  _this.table = $(_this.$el)
    .find("table")
    .DataTable(options);
  const fields = [
    {
      label: `${_this.t("Phone")}`,
      name: "phone",
      type: "telephone",
      opts: {
        initialCountry: "auto",
        geoIpLookup: success => {
          const countryItem = localStorage.getItem("countryInfo");
          if (countryItem) {
            const countryData = JSON.parse(countryItem);
            success(countryData.country);
          } else {
            $.get(
              "https://ipinfo.io/?token=c5eaed9fc0b066",
              () => {},
              "jsonp"
            ).always(resp => {
              localStorage.setItem("countryInfo", JSON.stringify(resp));
              const countryCode = resp && resp.country ? resp.country : "us";
              success(countryCode);
            });
          }
        }
      }
    },
    {
      label: `${_this.t("Name")}`,
      name: "name"
    },
    {
      label: `${_this.t("Group")}`,
      name: "group",
      type: "select",
      def: "",
      ipOpts: groups
    }
  ];
  const fieldsEdit = [
    {
      label: `${_this.t("Name")}`,
      name: "name"
    },
    {
      label: `${_this.t("Group")}`,
      name: "group",
      type: "select",
      def: "",
      ipOpts: groups
    }
  ];

  const phoneErrorMap = [
    "Invalid number",
    "Invalid country code",
    "Too short",
    "Too long",
    "Invalid number"
  ];

  const ajax = (method, url, d, success, error) => {
    let output = { data: [] };
    switch (d.action) {
      case "create":
        const client = d.data[0];
        const clientId = _this.md5(client.phone.number);
        if (
          _this.user.settings &&
          _this.user.settings.clients &&
          _this.user.settings.clients[clientId]
        ) {
          output.fieldErrors = [{ name: "phone", status: "already exists" }];
          success(output);
        } else if (!client.phone.validation.valid) {
          const status = phoneErrorMap[client.phone.validation.errorCode];
          output.fieldErrors = [{ name: "phone", status }];
          success(output);
        } else {
          const update = {};
          update[`settings.clients.${clientId}`] = JSON.parse(
            JSON.stringify(client)
          );
          client.DT_RowId = clientId;
          client.phone = client.phone.formatted.international;
          output.data.push(client);
          success(output);
          _this.$store.state.db
            .collection("users")
            .doc(_this.ref.id)
            .update(update)
            .then(() => {
              applyClientsRangeDate(_this.startDate, _this.endDate);
            });
        }
        break;
      case "edit": {
        (async () => {
          const update = {};
          for (const id of Object.keys(d.data)) {
            const value = d.data[id];
            const rowData = _this.table.row("#" + id).data();
            const data = $.extend({}, rowData, value);
            const newData = $.extend(
              {},
              _this.user.settings.clients[id],
              value
            );
            update[`settings.clients.${id}`] = newData;
            data.group = groups.find(({ value }) => value === data.group).label;
            output.data.push(data);
          }
          success(output);
          try {
            await _this.$store.state.db
              .collection("users")
              .doc(_this.ref.id)
              .update(update);
          } catch (e) {
            console.log(e);
          }
        })();
        break;
      }
      case "remove":
        success(output);
        async.eachOf(
          d.data,
          (value, id, callback) => {
            const update = {};
            update[
              `settings.clients.${id}`
            ] = _this.firebase.firestore.FieldValue.delete();
            _this.$store.state.db
              .collection("users")
              .doc(_this.ref.id)
              .update(update)
              .then(() => callback());
          },
          error => {}
        );
        break;
    }
  };
  const editor = _this.createEditor(_this, fields, ajax);
  const editorEdit = _this.createEditor(_this, fieldsEdit, ajax);
  const buttons1 = [
    {
      extend: "create",
      editor,
      text: '<span class="icon s7-plus"></span>',
      titleAttr: _this.t("Add"),
      formTitle: (editor, dt) => editor.i18n.create.title
    },
    {
      extend: "edit",
      editor: editorEdit,
      text: '<span class="icon s7-pen"></span>',
      titleAttr: _this.t("Edit"),
      formTitle: (editor, dt) => editor.i18n.edit.title
    },
    {
      extend: "remove",
      editor,
      text: '<span class="icon s7-trash"></span>',
      titleAttr: _this.t("Remove")
    }
  ];
  const buttons2 = [];
  _this.createButtons(_this, buttons1, buttons2);

  const tableId = _this.table
    .containers()[0]
    .getAttribute("id")
    .split("_")[2];

  $(`<div class="dt-buttons btn-group dt-header-buttons right">
            <div id="clients-date-range" class="date-range" style="background: #fff; cursor: pointer; border: 1px solid #ccc; padding: 0 10px; padding-right: 6px;">
            <i class="icon s7-date"></i>&nbsp;
            <span></span> <i class="fa fa-caret-down"></i>
        </div>
    </div>`).prependTo(`#DataTables_Table_${tableId}_wrapper`);

  const clientsDateRangeCb = (start, end) => {
    $("#clients-date-range span").html(
      start.format("ll") + " - " + end.format("ll")
    );
  };

  $("#clients-date-range").daterangepicker(
    {
      startDate: _this.startDate,
      endDate: _this.endDate,
      ranges: _this.ranges,
      opens: "left"
    },
    clientsDateRangeCb
  );

  clientsDateRangeCb(_this.startDate, _this.endDate);

  const applyClientsRangeDate = async (startDate, endDate) => {
    _this.table.processing(true);
    const users = _this.clients.map(client => client.snapshot.id);
    const clientsResponse = await _this.serviceRequest("getClientsUsage", {
      users,
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD")
    });
    const clients = _this.arrayToObject(clientsResponse, [
      /* "user",  */ "client"
    ]);
    _this.table.data().map(value => {
      const clientId = value.DT_RowId;
      const client = clients[clientId];
      if (client) {
        _this.table
          .row((idx, data) => data.DT_RowId === value.DT_RowId)
          .data(Object.assign(value, client));
      } else {
        _this.table
          .row((idx, data) => data.DT_RowId === value.DT_RowId)
          .data(
            Object.assign(value, {
              jobs: 0,
              total: 0,
              black: 0,
              color: 0,
              prints: 0,
              copies: 0,
              scans: 0
            })
          );
      }
    });

    _this.table
      .column("total:name")
      .order("desc")
      .draw();
    _this.table.processing(false);
  };

  $("#clients-date-range").on("apply.daterangepicker", (event, picker) => {
    event.preventDefault();
    const { startDate, endDate } = picker;
    applyClientsRangeDate(startDate, endDate);
  });

  applyClientsRangeDate(_this.startDate, _this.endDate);
};



// WEBPACK FOOTER //
// ./src/mixins/Clients.js